// extracted by css-extract-rspack-plugin
export default {"cls1":"NewsHeader-cls1_F-x","cls2":"NewsHeader-cls2_LM1 NewsHeader-cls1_F-x","variant-dense":"NewsHeader-variant-dense_XqZ"};